<template>
    <div>
        <a @click="generateReportCer(dataCancelPrint.id)">
            <a-icon :style="{ color: '#4D4C7D', fontSize: '20px' }" type="printer" />
        </a>
        <div style="display: none" :id="`printCer-${dataCancelPrint.id}`">
            
            <div class="mt-5 mb-5">
                <div class="mb-5 text-center">
                    <img style="height: 10%;" class="logo-size" src="../../../../public/images/logo_muic.png" alt="imag_pdfprint_1" />
                </div>

                <p class="mt-1 mb-1">IC Vehicle Booking System.</p>
                <i><p class="text-muted mt-1 mb-2">Request update at :: {{ moment(dataCancelPrint.updated_at).format('DD / MMMM / YYYY HH:mm') }}</p></i>

                <table class="table table-striped">
                    <thead>
                        <tr >
                            <th style="background-color: #000000;color: #ffffff;" width="15%" scope="col">#</th>
                            <th style="background-color: #000000;color: #ffffff;" scope="col">Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">Reason ::</th>
                            <td>
                                <p class="mt-0 mb-0">{{ dataCancelPrint.reason_detail.eng_detail }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Passenger ::</th>
                            <td>
                                <p class="mt-0 mb-0">{{ dataCancelPrint.passenger }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Destination ::</th>
                            <td>
                                <p class="mt-0 mb-0">{{ dataCancelPrint.destination }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Remark ::</th>
                            <td>
                                <p class="mt-0 mb-0">{{ dataCancelPrint.remark }}</p>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Date ::</th>
                            <td>
                                <p class="mt-0 mb-2">Start :: {{ moment(dataCancelPrint.use_start).format('DD / MMMM / YYYY HH:mm') }}</p>
                                <p class="mt-0 mb-0">End :: {{ moment(dataCancelPrint.use_end).format('DD / MMMM / YYYY HH:mm') }}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import VueHtml2pdf from "vue-html2pdf";
export default {
    components: {
        VueHtml2pdf,
    },
    props: {
        dataCancelPrint: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {}
    },
    methods: {
        async generateReportCer(id) {
            await this.$htmlToPaper(`printCer-${id}`, `@media print {
                    @page {size: A4 portrait;}
                }`,);
        },
    },
}
</script>